import { LoadingIndicator } from '@Wonder-Cave/ui';
import { SystemNumberStatusEnum } from '@shared/enums/system-number-status-enum';
import { FilterDataTypeEnum } from '@shared/models';
import { capitalize } from '@shared/services';
import { IClientLocalSystemNumberRecord } from '../../../../hooks/useClientLocalSystemNumbers';
import { formatPhoneNumber } from '../../../Numbers/types';
import { getAreaCode, normalizePhoneDigits } from './number-management.helpers';

export const buildColumns = (deactivatingIds: string[]) => [
  {
    headerName: 'Number',
    fieldName: 'phoneNumber',
    fieldType: FilterDataTypeEnum.STRING,
    isRowHeader: true,
    renderColumn: (item: IClientLocalSystemNumberRecord) => (
      <span>{formatPhoneNumber(normalizePhoneDigits(item?.phoneNumber))}</span>
    ),
  },
  {
    headerName: 'TCR Campaign',
    fieldName: 'tcrCampaignId',
    fieldType: FilterDataTypeEnum.STRING,
    renderColumn: (item: IClientLocalSystemNumberRecord) => (
      <span>{item?.tcrCampaignId ?? 'N/A'}</span>
    ),
  },
  {
    headerName: 'Status',
    fieldName: 'status',
    fieldType: FilterDataTypeEnum.STRING,
    renderColumn: (item: IClientLocalSystemNumberRecord) => (
      <div className='flex items-center'>
        <span>{item?.status ? capitalize(item.status) : ''}</span>
        {deactivatingIds.includes(item?.id) && <LoadingIndicator className='ml-2' size={4} />}
      </div>
    ),
  },
  {
    headerName: 'Provider',
    fieldName: 'providerName',
    fieldType: FilterDataTypeEnum.STRING,
    renderColumn: (item: IClientLocalSystemNumberRecord) => (
      <span>{item?.providerName ?? 'N/A'}</span>
    ),
  },
  {
    headerName: 'Actions',
    fieldName: 'actions',
    fieldType: FilterDataTypeEnum.ACTIONS,
  },
];
